export default __webpack_public_path__ + "static/media/Aspen Technologies.51a997a1.png";